import React from 'react';
import { Button, Toast, Icon } from 'antd-mobile';
import {post} from '../../../utils/request';
import { href } from '../../../utils/util';

import './index.less';


class InvitationEdit extends React.Component {
    constructor(...props) {
        super(...props);
        this.state = {

        };
        
    }


    
    render() {
        let { type } = this.state;
        return (
            <div className="InvitationEditBox">
                <div>
                    <div>
                        <h3>修改邀请人</h3>
                        <input id="YQR" type="tel" maxLength="11" placeholder="请填写邀请人的注册手机号" />
                        <Button type="primary" onClick={()=>{
                            var tel = document.getElementById('YQR').value;
                            if (tel && tel.length === 11 && tel.match(/^1(3|4|5|6|7|8|9)\d{9}$/)) {
                                this.props.onQuery(tel);
                            } else {
                                Toast.info('请输入正确的手机号',1);
                            }
                            return
                        }}>确定修改</Button>
                    </div>
                    <Icon onClick={()=>{
                        this.props.onQuit(false);
                    }} type="cross" />
                </div>
            </div>
        );
    }
}

export default InvitationEdit;


// WEBPACK FOOTER //
// ./src/invitation/modules/edit/index.js